import {useMemo} from 'react';
import {
	useSingleFileUploadForm,
	type UseSingleFileUploadFormParams,
	type SingleFileUploadFormValues,
} from '@netx/core-upload-next/hooks/useSingleFileUploadForm';

export interface AssetViewUploadFormValues extends SingleFileUploadFormValues {
	assetId: number;
}

export interface UseAssetViewUploadFormParams
	extends Omit<
		UseSingleFileUploadFormParams<AssetViewUploadFormValues>,
		'defaultValues'
	> {
	assetId: number;
}

export const useAssetViewUploadForm = ({
	assetId,
	...props
}: UseAssetViewUploadFormParams) => {
	const defaultValues = useMemo(() => ({assetId}), [assetId]);
	return useSingleFileUploadForm<AssetViewUploadFormValues>({
		...props,
		defaultValues,
	});
};
